// extracted by mini-css-extract-plugin
export default {"body":"styles_body__NlTp0","addbutton":"styles_addbutton__h5YTc","actionButton":"styles_actionButton__aQ-HE"};